import React, { useEffect, useState ,useRef } from "react";
import { useGoogleMaps } from "../../../../../../../../../../../utils/mapConfig";
import {
  Autocomplete,
  GoogleMap,
  MarkerF,
} from "@react-google-maps/api";
import { Col, Row } from "react-bootstrap";
import RoomIcon from "@mui/icons-material/Room";
import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import WrongLocationIcon from "@mui/icons-material/WrongLocation";
import SaveIcon from "@mui/icons-material/Save";
import { Button } from "@mui/material";
import "./mapLocation.css";

const MapLocation = ({
  booking,
  setLatitude,
  setLongitude,
  latitude,
  longitude,
}) => {
  const [center, setCenter] = useState({ lat: 0, lng: 0 });
  const [currentLocation, setCurrentLocation] = useState(null);
  const [drawingMode, setDrawingMode] = useState(null);
  const drawingModeRef = useRef(null);
  const [initialLocation, setInitialLocation] = useState(null);
  const [autocomplete, setAutocomplete] = useState(null);
  const [bookingLocationEditable, setBookingLocationEditable] = useState(false);
  const [selected, setSelected] = useState(null);

  const { isLoaded } = useGoogleMaps();

  const options = {
    streetViewControl: false,
    fullscreenControl: false,
    draggableCursor: drawingMode === "marker" ? "crosshair" : undefined,

  };

  useEffect(() => {
    if (booking?.latitude && booking?.longitude) {
      const { latitude: bookingLat, longitude: bookingLng } = booking;
      setLatitude(bookingLat);
      setLongitude(bookingLng);
    }
  }, [booking, setLatitude, setLongitude]);

  useEffect(() => {
    if (latitude && longitude) {
      setCenter({ lat: parseFloat(latitude), lng: parseFloat(longitude) });
    } else if (!initialLocation && currentLocation) {
      setCenter(currentLocation);
      setInitialLocation(currentLocation);
    }
  }, [latitude, longitude, currentLocation, initialLocation]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const location = { lat: latitude, lng: longitude };
          setCurrentLocation(location);
          if (!initialLocation) {
            setCenter(location);
            setInitialLocation(location);
          }
        },
        (error) => {
          console.error("Error fetching current location:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }, [initialLocation]);

  const handlePlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();

      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        setCenter({ lat, lng });
        setLatitude(lat);
        setLongitude(lng);
      }
    }
  };

  useEffect(() => {
    let originalParent;

    const handleFullscreenChange = (event) => {
      const target = event.target;
      const mapControls = document.querySelector(".map-controls-inside-maps");

      if (mapControls) {
        if (document.fullscreenElement === target) {
          originalParent = mapControls.parentElement;
          if (selected === 3) {
            target.appendChild(mapControls);
          } else {
            if (target.contains(mapControls)) {
              target.removeChild(mapControls);
            }
          }
        } else if (originalParent) {
          originalParent.appendChild(mapControls);
        }
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [selected]);

  const handleMapClick = (event) => {
    if (drawingModeRef.current !== "marker") return; 
  
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
  
    setCenter({ lat, lng });
    setBookingLocationEditable(true);
    setDrawingMode(null);
    drawingModeRef.current = null; 
  };
  const handleDrawToggle = () => {
    const newMode = drawingMode === "marker" ? null : "marker";
    setDrawingMode(newMode);
    drawingModeRef.current = newMode; 
  };

  const handleSubmit = () => {
    if (center) {
      setLatitude(center.lat);
      setLongitude(center.lng);
      setBookingLocationEditable(false);
    }
  };

  const handleClear = () => {
    setCenter(null);
  };

  return isLoaded ? (
    <div
      onClick={() => {
        setSelected(3);
      }}
    >
      <GoogleMap
        mapContainerClassName="appmap"
        center={center}
        zoom={14}
        options={options}
        onClick={handleMapClick}
      >
        <div className="map-controls-inside-maps">
          <Row className="align-items-center map-btn-controls">
            <Col className="d-flex justify-content-center">
              <Autocomplete
                onLoad={(autocompleteInstance) => {
                  setAutocomplete(autocompleteInstance);
                }}
                onPlaceChanged={handlePlaceChanged}
                className="map-input"
              >
                <input
                  type="text"
                  placeholder="Search location"
                  className="autocomplete-input"
                  style={{
                    width: "260px",
                    padding: "10px",
                    margin: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    position: "relative",
                  }}
                />
              </Autocomplete>
            </Col>
            <Col>
              <div className="map-control-btnss">
                <Button
                  className="map-submit-btn"
                  variant="contained"
                  color="primary"
                  onClick={handleDrawToggle}
                >
                  {drawingMode ? <EditLocationAltIcon /> : <RoomIcon />}
                </Button>

                <Button
                  className="map-submit-btn"
                  variant="contained"
                  color="error"
                  onClick={handleClear}
                >
                  <WrongLocationIcon />
                </Button>
                <Button
                  className="map-submit-btn"
                  variant="contained"
                  color="success"
                  onClick={handleSubmit}
                  disabled={!bookingLocationEditable}
                >
                  <SaveIcon />
                </Button>
              </div>
            </Col>
          </Row>
        </div>
        {/* {drawingMode === "marker" && (
          <DrawingManager
            options={{
              drawingControl: true,
              drawingControlOptions: {
                position: window.google.maps.ControlPosition.TOP_RIGHT,
                drawingModes: ["marker"],
              },
            }}
            onMarkerComplete={handleMapClick}
          />
        )} */}
        {center && <MarkerF position={center} />}
      </GoogleMap>
    </div>
  ) : (
    <div>Loading Map...</div>
  );
};

export default MapLocation;
